import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=597981c6&scoped=true"
import script from "./DealsPage.vue?vue&type=script&lang=js"
export * from "./DealsPage.vue?vue&type=script&lang=js"
import style0 from "./DealsPage.vue?vue&type=style&index=0&id=597981c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597981c6",
  null
  
)

export default component.exports